import { round } from './round';

export function deunit(value: number, unit: number): number {
  return round(value / 1000 ** unit, 1);
}
